<template>
    <div>
        <v-card>
            <v-card-title>
                <span class="text-h5">Cambio de Producto</span>
            </v-card-title>
            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="4" sm="4" md="4" class="pb-0">
                            <v-text-field
                                v-model="productActually.product.description"
                                label="Producto Actual"
                                outlined
                                auto-select-first
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="6" class="pb-0">
                            <v-autocomplete
                                v-model="newProduc"
                                :items="itemsProducts"
                                label="Nuevo Producto"
                                outlined
                                auto-select-first
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field
                                v-model="newQuantity"
                                label="Cantidad"
                                outlined
                                required
                                type="number"
                            ></v-text-field>
                        </v-col>                                              
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel">
                    Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { getProductsItems } from '@/dataApi'
export default {
    name: 'changeItems',
    props: {
        productActually: {
            type: Object,
            default: null
        },
        quantity: {
            type: Number,
            default: 0
        },
    },
    data: () => ({
        comment: '',
        itemsProducts: [],
        newProduc: null,
        newQuantity: 0,
    }),
    async mounted() {
        this.itemsProducts = await getProductsItems();
        this.newProduc = this.productActually.productId;
        this.newQuantity = this.productActually.quantity;
        console.log(this.productActually)
    },
    methods: {
        cancel() {
            this.$emit('closeModal');
        },
        async save() {
            
            let changeRequestItemDto = {
                productOldId: this.productActually.productId,
                productNewId: this.newProduc,
                quantity: parseInt(this.newQuantity),
                quantityOld: parseInt(this.productActually.quantity),
                changeLock: false,
                zoneId: this.productActually?.requestItem?.request?.zoneId || 1,
            }
            
            this.$emit('saveProduct', changeRequestItemDto);
        },
    },

}
</script>